export const NUMBER_MASK = [
  {
    definitions: { '#': /[А-Яа-яЁё]/i },
    mask: ['00', '##', Array(6).fill('0').join('')].join(' '),
  },
  { mask: Array(15).fill('0').join('') },
];
